import { mutate } from 'swr';
import useStores from '@stores/useStores';
import { ApiGetResource, deleteAccountApi } from '@api';
import { getResourceCacheKey } from './useLoadAccountsIntoAccountManagementStore';

export const useDeleteAccounts = () => {
  const { workspaceStore, messagesStore } = useStores();

  return async (accountId: string, resourceDefinitionName: string) => {
    try {
      await deleteAccountApi(workspaceStore.id, accountId);
      await mutate(
        getResourceCacheKey(workspaceStore.id, resourceDefinitionName, ApiGetResource.ACCOUNTS),
      );
      return true;
    } catch (error) {
      messagesStore.showErrorMessage(error as string);
      return false;
    }
  };
};
